import { createAction } from '@reduxjs/toolkit';
import type { FormValues } from 'src/routes/Checkout/components/Client/ClientDataForm/types';
import {
  CONFIRM_CLIENT,
  RESET_CLIENT,
  ON_LOAD,
  FETCH_CLIENT_INFO,
  SUBMIT_CLIENT_DATA_FORM,
} from './constants';
import { clientSlice } from './slice';

export const {
  logInAction,
  logOutAction,
  signUpAction,
  showAuthAction,
  hideAuthAction,
  showLogOutAction,
  hideLogOutAction,
  setClientConfirmPhone,
  setClientInfo,
  setClientBonusScore,
  setClientAuthToken,
  setPhoneMaskAndCountryCode,
  setShowReCaptchaModal,
  setClientPartialInfo,
  setGuestDataSaved,
  setClientFormStatus,
  setGuestNameOrSurname,
} = clientSlice.actions;

export const confirmClientAction = createAction<boolean | null>(CONFIRM_CLIENT);
export const resetClientAction = createAction(RESET_CLIENT);

export const onLoadAction = () => ({
  type: ON_LOAD,
});

export const fetchClientInfo = createAction<undefined>(FETCH_CLIENT_INFO);

export const submitClientDataFormAction = createAction<FormValues>(
  SUBMIT_CLIENT_DATA_FORM,
);
